import * as Yup from "yup";

import { variables } from "../../Variables";

const { required, password_match } = variables;

export const updateSchema = Yup.object({
  old_password: Yup.string().required(required),
  new_password: Yup.string().required(required),
  confirm_new_password: Yup.string()
    .required(required)
    .oneOf([Yup.ref("new_password")], password_match),
});
